export default "__VITE_ASSET__DfM6yyOh__"